import React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import "../../Styles/Header.css";
import Appbar from "../../Component/NavPannel/Appbar";
import AccountingScreens from "../../Component/Layouts/AccountScreensLayout";

const mdTheme = createTheme();

function Accounting() {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex", height: "100vh" }}>
        <CssBaseline />
        <Appbar mainpage="Home" subpage="Accounting"/>
        <AccountingScreens />
      </Box>
    </ThemeProvider>
  );
}

export default function AccountScreen() {
  return <Accounting />;
}
